import styled from "styled-components";

const FeedbackByAttribute = ({ attributes }) => {

    return (
        <Container>
            <h1>Feedback por atributo</h1>
            {
                attributes.map(attribute => (
                    <span key={attribute.id}>
                        <label>
                            {attribute.name}: {attribute.score}/5
                        </label>
                        <p>
                            <b>Descripción: </b>
                            {attribute.description}
                        </p>
                        <p>
                            <b>Feedback: </b>
                            {attribute.feedback}
                        </p>
                    </span>
                ))
            }

        </Container>
    )
}

export default FeedbackByAttribute;

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    gap: 1rem;

    h1 {
        margin-bottom: 1rem;
    }

    span {
        width: calc(100% - 2rem);
        height: fit-content;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;
        gap: .5rem;
        padding: 1rem;
        border-left: 8px solid #b31d15;
        background-color: #f1f1f1;
        border-radius: 8px;

        label {
            font-size: 20px;
            font-weight: 900;
        }

        p {
            font-size: 16px;
        }
    }
`
